import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { Formik } from 'formik';

import Wrapper from '../../shared/Wrapper';
import Splash from '../../shared/Splash';
import Testimonials2 from '../../shared/Testimonials2';
import Footer from '../../shared/Footer';
import FeaturedCoursesByIndustry from './FeaturedCoursesByIndustry';

import { getNurseOptions } from '../../../fixture/data';
import { withRouter } from 'react-router-dom';
import NurseSplash from '../../../assets/nurseBanner.jpg';
import ProfessionalImg from '../../../assets/professional.png';
import NurseAccredited1 from '../../../assets/nurse_accredited1.png';
import NurseAccredited2 from '../../../assets/nurse_accredited2.png';
import NurseAccredited3 from '../../../assets/nurse_accredited3.png';
import NurseAccredited4 from '../../../assets/nurse_accredited4.png';
import NurseAccredited5 from '../../../assets/nurse_accredited5.png';
import NurseAccredited6 from '../../../assets/nurse_accredited6.png';
import Nurse from '../../../assets/nurse.png';
import NurseBg from '../../../assets/nurseBg.jpg';

import {
  Subtitle,
  Text,
  Container,
  Form,
  StyledRow,
  Label,
  StyledSelect,
  Button,
  SubscribeEmail,
} from '../../theme/index';

const CenterSubtitle = styled(Subtitle)`
  color: ${props => props.color || 'white'};
  text-align: center;
  span {
    color: ${props => props.spanColor || '#ffaf77'};
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 30px 10px;
  img {
      display flex;
      margin: 10px 25px;
      height: 90px;
      width: auto;
  }
`;

const FeaturedContainer = styled.div`
  text-align: center;
  width: 100%;
  height: 800px;
  background: ${props => props.background};
  background-size: cover;
  background-position: bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 720px) {
    height: 100%;
    padding: 2em 0;
  }
  img {
    margin-bottom: 10px;
  }

  hr {
    margin: 25px 400px;
    border: 1px solid #ffaf77;
  }
`;

const StyledDiv = styled.div`
  margin-top: 10em;
  width: 100%;
  @media (max-width: 720px) {
    margin-top: 18em;
  }
`;

class Nursing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profession: [{ label: 'Select a state first', value: null }],
    };
  }

  render() {
    const { history = {} } = this.props;
    return (
      <Wrapper>
        <Helmet
          title="AchieveCE | Approved Continuing Education"
          meta={[
            { name: 'description', content: 'Nursing Page for AchieveCE' },
            { property: 'og:type', content: 'website' },
            { property: 'og:title', content: 'Approved Continuing Education' },
            { property: 'og:url', content: 'http://achievece.com/nursing' },
          ]}
        />
        <Splash
          text={['Approved Nursing CEUs', 'Choose your state and profession']}
          img={NurseSplash}
          id="nursing"
          navigate={this.props.history}
        >
          <CenterSubtitle>
            ALL NURSING COURSES ACCREDITED AND ACCEPTED IN ALL 50 US STATES
          </CenterSubtitle>
        </Splash>
        <Container textalign="center">
          <img src={ProfessionalImg} alt="Professional icon" height="90" />
          <CenterSubtitle color="black">
            ACCREDITED AND APPROVED <span>BY</span>
          </CenterSubtitle>
          <ImageContainer>
            <img
              src={NurseAccredited1}
              alt="agency for healthcare"
              height="auto"
            />
            <img src={NurseAccredited2} alt="bvnpt" />
            <img src={NurseAccredited3} alt="board of nursing" />
            <img src={NurseAccredited4} alt="cebroker" />
            <img src={NurseAccredited5} alt="california board" />
            <img src={NurseAccredited6} alt="elder affairs florida" />
          </ImageContainer>
          <Text textalign="center">
            *ALL NURSING COURSES ACCREDITED AND ACCEPTED IN ALL 50 US STATES
          </Text>
        </Container>
        {/* TODO: send the industry name taking from the url */}
        <FeaturedContainer background={`url('${NurseBg}')`}>
          <StyledDiv>
            <img src={Nurse} alt="Nurse icon" height="90" />
            <CenterSubtitle color="black">FEATURED COURSES</CenterSubtitle>
            <hr />
            <p>A few of our most popular products.</p>
            <p>Select yours bellow for a seamless renewal experience.</p>
            <FeaturedCoursesByIndustry industryName="nursing" />
          </StyledDiv>
        </FeaturedContainer>
        <Container background="#15324B">
          <CenterSubtitle color="white" spanColor="white">
            Don't see what you're looking for?{' '}
            <span style={{ textDecoration: 'underline' }}>
              Choose your State and Profession
            </span>{' '}
            here:
          </CenterSubtitle>
          <Formik
            initialValues={{ state: '', profession: '' }}
            onSubmit={values => {
              let state = values.state.label.replace(/\s+/g, '-');
              let profession = values.profession.label.replace(/\s+/g, '-');
              history.push(`${profession}/${state}`);
            }}
            render={({ values, handleBlur, handleSubmit, setFieldValue }) => (
              <Form
                style={{ width: 'auto', paddingBottom: '40px' }}
                onSubmit={handleSubmit}
              >
                <StyledRow>
                  <Label htmlFor="state">
                    <StyledSelect
                      required
                      type="state"
                      id="state"
                      placeholder="State"
                      options={getNurseOptions('state')}
                      onChange={value => {
                        setFieldValue('state', value);
                        this.setState({
                          profession: getNurseOptions('profession', value),
                        });
                      }}
                      onBlur={handleBlur}
                      value={values.state}
                    />
                  </Label>
                  <Label htmlFor="profession">
                    <StyledSelect
                      required
                      type="profession"
                      id="profession"
                      placeholder="Profession"
                      options={this.state.profession}
                      onChange={value => {
                        setFieldValue('profession', value);
                      }}
                      onBlur={handleBlur}
                      value={values.profession}
                    />
                  </Label>
                </StyledRow>
                <Button home type="submit">
                  Find your ce
                </Button>
              </Form>
            )}
          />
        </Container>
        <Testimonials2 />
        <Container
          background="white"
          style={{ textAlign: 'center', paddingTop: '0' }}
        >
          <CenterSubtitle color="black">SIGN UP FOR 10% OFF</CenterSubtitle>
          <p>Yes! It's that easy!</p>
          <p>We're here to make sure that you have</p>
          <p> seamless and enjoyable CE renewal.</p>
          <p>Include your email for updates and discounts.</p>
          <SubscribeEmail submit={() => {}}>
            <input type="text" placeholder="Enter your email" />
            <button type="submit">
              <i class="fas fa-hand-point-right" /> Subscribe
            </button>
          </SubscribeEmail>
        </Container>
        <Footer />
      </Wrapper>
    );
  }
}

export default withRouter(Nursing);



// WEBPACK FOOTER //
// ./src/components/screens/Industry/Nursing.jsx